import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { whiteListIPConfig } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
const WhiteListIPMaster = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);

  const handleCreateDueDiligence = () => {
    navigate(whiteListIPConfig?.createUrl);
  };

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    getAllBranchDetails();
  }, []);
  
  const getAllBranchDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_ALL_BRANCH,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      GetData(result?.data);
    }
  };

  const GetData = async (branchList) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FINDALL_IP_WHITE_LIST_MASTER,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.user_description) {
      toastUpdate(toastAction?.error, result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data, branchList);
    }
  };

  const parseIndicatorData = (data, branchList) => {
    let reportData = [];
    data &&
      data.forEach((item, index) => {
        const branch = branchList?.find((b) => b.code === item?.branchCode);
        const branchName = branch ? branch?.name : item?.branchCode;
        let row = {
          index: index + 1,
          branchName: branchName,
          enabled: item?.enabled === true ? "Yes" : "No",
          whitelistIp: item?.whitelistedIps?.join(", "),
          action: getIcons(item?.id),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };

  const getIcons = (id) => {
    return (
      <>
        <IconButton aria-label="Edit id" onClick={() => onClickUpdateData(id)}>
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete id"
          onClick={() => onClickDeleteData(id)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };

  const onClickUpdateData = (id) => {
    navigate(whiteListIPConfig?.updateUrl + id);
  };

  const onClickDeleteData = (id) => {
    setConfirmationModalHeader(whiteListIPConfig?.confirmationHeader);
    setConfirmationModalMsg(whiteListIPConfig?.confirmationMsg);
    setDeleteId(id);
    setConfirmationModal(true);
  };

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteId("");
  };

  const handlePositiveResponse = async () => {
    const id = deleteId;
    handleNegativeResponse();
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.DELETE_BY_ID_IP_WHITE_LIST_MASTER + id,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
    } else {
      toastUpdate(toastAction?.success,whiteListIPConfig?.successMsg, true);
      GetData();
    }
  };

  const onSearchChange = (event) => {
    const val = event.target.value?.toLowerCase();
    const filteredData = rawData.filter((row) => {
      return (
        row?.branchCode?.toLowerCase()?.includes(val) ||
        row?.whitelistedIps?.some((ip) => ip?.toLowerCase()?.includes(val))
      );
    });
    parseIndicatorData(filteredData);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label={whiteListIPConfig?.label}
          onSearchChange={onSearchChange}
          searchLabel={whiteListIPConfig?.searchLabel}
          search
          button1={whiteListIPConfig?.button}
          button1click={handleCreateDueDiligence}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={whiteListIPConfig?.tableColumns}
          rows={selectedTableData}
        />
      </GridItem>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

export default WhiteListIPMaster;
